(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,EDGES,GROUND_HARDWARE,SIDE_PULLS,DOOR_ENDS,INTERNAL_RIDGELINE,GLOWIRE,RIDGELINE_CORD,POLES,STAKES,PATCH_KIT}=window.SLDEstimatorData.products["winter_haven"];
const TARP_SHARED=window.SLDEstimatorData.shared.tarps;
const CONTROLS=window.SLDEstimatorData.productControls.winterHaven;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric',
    "Length * (required)": 'Length',
    'Tarp Edges * (required)': 'Edge',
    'Ground Tie Outs * (required)': 'Ground Hardware',
    "Side Panel Pull Outs * (required)": 'Side Panel Pull Outs',
    "Door Ends * (required)": 'Door Ends',
    'Internal Ridgeline * (required)': 'Internal Ridgeline',
    "Reflective Guyline Cord * (required)": 'Glowire',
    "Ridgeline Cord Options * (required)": 'Ridgeline Cord',
    "Tarp Pole Set * (required)": 'Tarp Pole Set',
    "Tent Stakes * (required)": 'Tent Stakes',
    'Patch Kit * (required)': 'Patch Kit'
  });

  
  
  
  
  
  
  
  
  
  
  
  
  const DEFAULTS = Object.freeze({
    Edge: 'Catenary Cut',
    'Ground Hardware': 'Loops Only',
    'Side Panel Pull Outs': 'None',
    'Door Ends': 'Standard Doors (NO Snaps)',
    'Internal Ridgeline': 'No',
    Glowire: 'None (I will use my own)',
    'Ridgeline Cord': 'None (I will use my own)',
    'Tarp Pole Set': 'No',
    'Tent Stakes': 'None (I will use my own)',
    'Patch Kit': 'No'
  });

  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
  const exactText = (value) => String(value || '').trim();

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const label=Object.keys(FIELD_LABELS).find(key=>key.replace(/\s+/g,' ').trim()===String(element.labels&&element.labels[0]&&element.labels[0].textContent||'').replace(/\s+/g,' ').trim());
      if (!own(FIELD_LABELS, label)) continue;
      selected[FIELD_LABELS[label]] = exactText(element.value);
    }
    return selected;
  }

  function preference(choice, field) {
    const value = choice[field];
    return value === undefined || value === '' ? DEFAULTS[field] : value;
  }

  function ridgeKitWeight(length) {
    return TARP_SHARED.internalRidgeline.baseWeightAt10Feet + (length - TARP_SHARED.internalRidgeline.baseLengthFeet) * TARP_SHARED.internalRidgeline.perFootAdjustment;
  }

  function poleSleeveWeight(count) {
    return TARP_SHARED.poles.sleevesPerPole * count * TARP_SHARED.poles.sleeveWeightEach;
  }

  function ridgeAnchorWeight() {
    return TARP_SHARED.internalRidgeline.anchorWeight;
  }

  function finishedPoleWidth(usableWidth) {
    return 2 * (usableWidth - 3);
  }

  function poleSystemWeight(count, poleWidth, length) {
    if (!count) return 0;
    return count * poleWidth * TARP_SHARED.poles.weightPerInch + poleSleeveWeight(count) + TARP_SHARED.poles.sackByCount[count] + ridgeKitWeight(length);
  }

  function estimate(choice) {
    if (choice.Fabric === 'Custom Fabric (Please Contact Me First)') return { manual: true };
    const fabric = FABRICS[choice.Fabric];
    const length = LENGTHS[choice.Length];
    if (!fabric || !length) return null;

    const edgeChoice = preference(choice, 'Edge');
    const groundChoice = preference(choice, 'Ground Hardware');
    const sideChoice = preference(choice, 'Side Panel Pull Outs');
    const doorChoice = preference(choice, 'Door Ends');
    const internalChoice = preference(choice, 'Internal Ridgeline');
    const glowireChoice = preference(choice, 'Glowire');
    const ridgelineCordChoice = preference(choice, 'Ridgeline Cord');
    const poleChoice = preference(choice, 'Tarp Pole Set');
    const stakeChoice = preference(choice, 'Tent Stakes');
    const patchChoice = preference(choice, 'Patch Kit');

    const edge = EDGES[edgeChoice];
    const hardware = GROUND_HARDWARE[groundChoice];
    const sidePulls = (Object.prototype.hasOwnProperty.call(SIDE_PULLS, sideChoice) ? SIDE_PULLS[sideChoice] : undefined);
    const doorSnaps = DOOR_ENDS[doorChoice];
    const internalRidgeline = INTERNAL_RIDGELINE[internalChoice];
    const glowire = GLOWIRE[glowireChoice];
    const ridgelineCord = RIDGELINE_CORD[ridgelineCordChoice];
    const poleCount = POLES[poleChoice];
    const stakes = STAKES[stakeChoice];
    const patchKit = PATCH_KIT[patchChoice];
    if (!edge || hardware === undefined || sidePulls === undefined || doorSnaps === undefined || internalRidgeline === undefined || glowire === undefined || ridgelineCord === undefined || poleCount === undefined || stakes === undefined || patchKit === undefined) return null;

    const rawLength = length * 12 + (doorSnaps ? 4 : 3);
    const preCutArea = 2 * fabric.usableWidth * (rawLength + 16);
    const straightArea = preCutArea - TARP_SHARED.havenConstruction.doorBottomCutbackArea;
    const shortCatDeduction = edge.catenary ? 4 * TARP_SHARED.havenConstruction.shortCurveChord * 2 * TARP_SHARED.havenConstruction.shortCatFactor : 0;
    const longCatSpan = rawLength + 32 - TARP_SHARED.havenConstruction.longSpanCornerCutLength;
    const centerPoleCat = edge.catenary && (poleCount === 1 || poleCount === 3);
    const longCatDepth = centerPoleCat ? 2.5 : 3;
    const longCatDeduction = edge.catenary ? 2 * longCatSpan * longCatDepth * TARP_SHARED.havenConstruction.longCatFactor : 0;
    const body = (straightArea - shortCatDeduction - longCatDeduction) / 1296 * fabric.density;
    const perimeterReinforcement = TARP_SHARED.havenConstruction.havenBaseReinforcement;
    const ridgeReinforcement = 0;
    const loopWeight = TARP_SHARED.havenConstruction.cornerLoopLength * window.SLDEstimatorData.shared.components.grosgrain.oneHalfPerInch;
    const groundAssemblies = 8 * (loopWeight + hardware);
    const extraMidpoints = edge.extraMidpoints
      ? 2 * (TARP_SHARED.havenConstruction.midpointReinforcement + TARP_SHARED.havenConstruction.midpointLoopLength * window.SLDEstimatorData.shared.components.grosgrain.oneHalfPerInch + hardware)
      : 0;
    const catCenterAssemblies = centerPoleCat
      ? 2 * (TARP_SHARED.havenConstruction.fiveInTriangleReinforcement + loopWeight + hardware)
      : 0;
    const fixedRidgeTies = TARP_SHARED.havenConstruction.fixedRidgeTies;
    const snapCount = fabric.className === 'wide' ? CONTROLS.snapCounts.wide : CONTROLS.snapCounts.standard;
    const doorHardware = doorSnaps ? snapCount * TARP_SHARED.havenConstruction.doorSnapWeightEach : 0;
    const installedSidePulls = sidePulls === 'webbingLoops' ? 4 * TARP_SHARED.sidePulls.webbingLoopEach : sidePulls ? TARP_SHARED.sidePulls.assemblySet : 0;
    const seamSealing = length * TARP_SHARED.twoPanelSeam.baseSealPerFoot + (sidePulls ? TARP_SHARED.sidePulls.sealIncrement : 0);
    const baseFinished = body + perimeterReinforcement + ridgeReinforcement + groundAssemblies + extraMidpoints + catCenterAssemblies + fixedRidgeTies + doorHardware + TARP_SHARED.twoPanelSeam.hemThread + installedSidePulls + seamSealing;

    const hasRidge = !!poleCount || internalRidgeline;
    const installedPoleHardware = (poleCount ? poleSleeveWeight(poleCount) : 0) + (hasRidge ? ridgeAnchorWeight() : 0);
    const finished = baseFinished + installedPoleHardware;
    const poleWidth = finishedPoleWidth(fabric.usableWidth);
    const completeRidgeSystem = poleCount
      ? poleSystemWeight(poleCount, poleWidth, length)
      : internalRidgeline ? ridgeKitWeight(length) : 0;
    const removableRidgeSystem = completeRidgeSystem - installedPoleHardware;
    const sack = TARP_SHARED.mainSackWeight(straightArea-shortCatDeduction-longCatDeduction,choice.Fabric === 'Silpoly 1.6 (Choose from available solid colors at Ripstopbytheroll.com)',poleCount);
    const total = finished + sack + removableRidgeSystem + glowire + ridgelineCord + stakes + patchKit;

    return { body, finished, total, sack, edge: edgeChoice, poleWidth, removableRidgeSystem };
  }

  function start() {
    const root = document.querySelector('[data-sld-winter-haven-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const result = estimate(selections(scope));
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');
      if (!result || result.manual) {
        if (results) results.hidden = true;
        if (message) message.textContent = result && result.manual
          ? 'Custom fabrics require a manual weight estimate. Please contact me before ordering.'
          : 'Select your fabric and length to see the estimated weight.';
        return;
      }

      const tarpWeight = root.querySelector('[data-sld-weight-tarp]');
      const totalWeight = root.querySelector('[data-sld-weight-total]');
      if (tarpWeight) tarpWeight.textContent = result.finished.toFixed(1) + ' oz';
      if (totalWeight) totalWeight.textContent = result.total.toFixed(1) + ' oz';
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { estimate, finishedPoleWidth, poleSystemWeight, poleSleeveWeight, ridgeAnchorWeight, ridgeKitWeight, selections, start };
});
